import { combineReducers } from "redux";

import { EntitiesMap } from "../entities";
import entitiesReducer from "./entities";
import commonReducer, { CommonState } from "./common";
import showReducer, { ShowState } from "./show";
import aboutReducer, { AboutState } from "./about";
import membersReducer, { MembersState } from "./members";
import postsReducer, { PostsState } from "./posts";
import projectsReducer, { ProjectsState } from "./projects";

export interface CompaniesState {
  entities: EntitiesMap;
  common: CommonState;
  show: ShowState;
  about: AboutState;
  members: MembersState;
  posts: PostsState;
  projects: ProjectsState;
}

export const reducer = combineReducers({
  entities: entitiesReducer,
  common: commonReducer,
  show: showReducer,
  about: aboutReducer,
  members: membersReducer,
  posts: postsReducer,
  projects: projectsReducer,
});



// WEBPACK FOOTER //
// ./frontend/src/companies/reducers/index.ts